<ul>
  <li>
    <button htm-button (click)="openActionHistory()" theme="outline" data-test-id="sidebar-final-document-history-open-action-history-button">
      {{'finaldocuments.action_history' | translate}}
    </button>
  </li>
  <li>
    <button htm-button (click)="openIssueHistory()" theme="outline"  data-test-id="sidebar-final-document-history-open-issue-history-button">
      {{'finaldocuments.issue_history' | translate}}
    </button>
  </li>
</ul>

<htm-modal
  id="finalDocument-actionHistory"
  [modalTitle]="'finalDocumentHistory' | translate"
  [bottomAction]="true"
  wide
  >
  <ng-template>
    <h1 id="final-documents-action-history-title">{{'finaldocuments.action_history' | translate}}</h1>
    @if (loadingDownload) {
      <loader></loader>
    }
    <alerts id="documentAlerts"></alerts>
    @if (actionHistory.length > 0) {
      <scrollableContent scrollParentClass="modal__block">
        <table htm-table aria-labelledby="final-documents-action-history-title">
          <tr>
            <th></th>
            <th>{{'finaldocuments.th.action_type' | translate}}</th>
            <th>{{'finaldocuments.th.document_type' | translate}}</th>
            <th>{{'finaldocuments.th.time' | translate}}</th>
            <th>{{'finaldocuments.date_of_decision' | translate}}</th>
            <th>{{'finaldocuments.th.reason' | translate}}</th>
          </tr>
          @for (action of actionHistory; track action) {
            <tr>
              <td>
                @if (action.document?.id) {
                  <button
                    htm-button
                    theme="link"
                    (click)="openDocument(action.document)"
                    [attr.data-test-id]="'sidebar-final-document-history-action-history-open-document-button-' + action?.document?.id"
                    >
                    {{ 'button.open' | translate }}
                  </button>
                }
              </td>
              <td>{{'finalDocument_' + action.type | translate}}</td>
              <td>{{action.document.typeName}}</td>
              <td>{{action.added | date:"dd.MM.yyyy HH:mm"}}</td>
              <td>
                {{action.decisionNumber}} {{action.dateOfDecision
                | date:"dd.MM.yyyy"}}
              </td>
              <td>{{action.reason || '-'}}</td>
            </tr>
          }
        </table>
      </scrollableContent>
    } @else {
      <alerts id="historyModalAlerts"></alerts>
      <alerts id="actionHistoryModalAlerts"></alerts>
    }
  </ng-template>
</htm-modal>

<htm-modal
  id="finalDocument-issueHistory"
  [modalTitle]="'finalDocumentHistory' | translate"
  [bottomAction]="true"
  wide
  >
  <ng-template>
    <h1 id="final-documents-issue-history-title">{{'finaldocuments.issue_history' | translate}}</h1>
    @if (issuingHistory.length > 0) {
      <scrollableContent scrollParentClass="modal__block">
        <table htm-table aria-labelledby="final-documents-issue-history-title">
          <tr>
            <th>{{'finaldocuments.th.time' | translate}}</th>
            <th>{{'finaldocuments.th.user' | translate}}</th>
            <th>{{'finaldocuments.th.access_type' | translate}}</th>
            <th>{{'finaldocuments.th.action' | translate}}</th>
          </tr>
          @for (issue of issuingHistory; track issue) {
            <tr>
              <td>{{issue.issueTime | date:"dd.MM.yyyy HH:mm"}}</td>
              <td>
                @if (issue.issueBase === 'USER' && issue.certificateAccess) {
                  {{issue.certificateAccess.accessorCode}}
                }
                @if (issue.issueBase === 'ISSUER') {
                  {{data.issuerInstitution}}
                }
              </td>
              @if (issue.issueBase === 'ISSUER') {
                <td>
                  {{'finalDocument_issue_' + issue.issueBase | translate}}
                </td>
              }
              @if (issue.issueBase !== 'ISSUER') {
                <td>
                  @if (issue.certificateAccess.type === 'ACCESS_TYPE:ID_CODE') {
                    <p
                      >
                      {{'frontpage.isikukood' | translate}}
                    </p>
                  }
                  @if (issue.certificateAccess.type === 'ACCESS_TYPE:ACCESS_CODE') {
                    <p>{{'finaldocuments.accessCode' | translate}}</p>
                    <p>{{issue.certificateAccess.emailAddress}}</p>
                  }
                  @if (issue.certificateAccess.type === 'ACCESS_TYPE:DISCLOSURE') {
                    <p
                      >
                      {{'certificates.disclosure' | translate}}
                    </p>
                  }
                </td>
              }
              <td>{{'finalDocument_issue_' + issue.issueType | translate}}</td>
            </tr>
          }
        </table>
      </scrollableContent>
    } @else {
      <alerts id="historyModalAlerts"></alerts>
      <alerts id="actionHistoryModalAlerts"></alerts>
    }
  </ng-template>
</htm-modal>

<htm-modal
  id="finalDocument-document"
  modalTitle="Dokument"
  [bottomAction]="true"
  wide
  >
  <ng-template>
    @if (loadingDocument) {
      <loader></loader>
    }
    @if (!loadingDocument && !loadingDocumentError) {
      @if (documentToShow.type === 'GRADUATION_DOCUMENT_TYPE:BASIC_EDUCATION_CERTIFICATE' || documentToShow.type === 'GRADUATION_DOCUMENT_TYPE:GENERAL_EDUCATION_CERTIFICATE') {
        <certificate
          [document]="documentCache[documentToShow.id]"
          >
        </certificate>
      } @else {
        <certificate-grade-sheet
          [document]="documentCache[documentToShow.id]"
        ></certificate-grade-sheet>
      }
    }
    <alerts id="documentAlerts"></alerts>
  </ng-template>
</htm-modal>

